module.exports = __webpack_public_path__ + "static/MMO-89b4238e4363e77d95b9e377c917d9f3.png";